import NewsLetterForm from './newsletter-form';
import CareerForm from './career-form'
import ContactForm from './contact';

const Form = {
    init() {
        this._initValidations();
    },
    _initValidations() {
        NewsLetterForm.init();
        ContactForm.init();
        CareerForm.init();

    },

}
export default Form;



// WEBPACK FOOTER //
// ./scripts/modules/forms/form.js